import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, InputNumber, notification} from 'antd';

import {changeProductSalePrice, getProduct} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ChangeProductSalePriceForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.productId !== prevProps.match.params.productId) this._load();
  }

  _load() {
    const {productId} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {productId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.changeProductSalePrice({...values, productId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, product} = this.props;
    return (
      <Card title="Change Product Sale Price">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Product"
          >
            {product.display}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Sale Price"
          >
            {getFieldDecorator('salePrice', {initialValue: product.salePrice})(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Change Product Price
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

ChangeProductSalePriceForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  changeProductSalePrice: PropTypes.func.isRequired,
  getProduct: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const ChangeProductSalePricePage = Form.create()(ChangeProductSalePriceForm);

const mapStateToProps = state => ({
  product: state.product.product || {},
  loading: state.product.productLoading || state.product.changingProductSalePrice,
});

const mapDispatchToProps = dispatch => ({
  changeProductSalePrice: bindActionCreators(changeProductSalePrice, dispatch),
  getProduct: bindActionCreators(getProduct, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeProductSalePricePage);



// WEBPACK FOOTER //
// ./src/Product/ChangeProductSalePricePage.js